import React, { useState } from 'react';
import { Place, Search } from '@mui/icons-material';
import { Colors } from 'library';
import { IconButton, Stack, Text, TextInput } from 'library/ui';
import { StaffFilterOptions, defaultFilters } from 'parent-portal/shared/filterOptions';

export default function ZipSearch({
    zipCode,
    updateZipCode,
    search,
}: {
    zipCode: string;
    updateZipCode: (value: string) => void;
    search: (filters: StaffFilterOptions) => void;
}) {
    const [showHelperText, setShowHelperText] = useState(false);

    function onSearch() {
        if (zipCode.length < 5) {
            setShowHelperText(true);
        } else {
            setShowHelperText(false);
            search(defaultFilters);
        }
    }

    return (
        <Stack gap="sm">
            <Text weight="bold">Zip Code</Text>
            <TextInput
                value={zipCode}
                onChange={updateZipCode}
                onSubmit={onSearch}
                placeholder="Zip Code"
                color="white"
                fullWidth
                error={showHelperText ? 'Please enter a valid zip code' : undefined}
                startAdornment={<Place style={{ color: Colors.primary }} />}
                endAdornment={<IconButton onClick={onSearch} icon={Search} variant="filled" />}
            />
        </Stack>
    );
}
